import { DataManagerComponent } from 'plugins/types';

import { useDataManager } from '../useDataManager';
import { useConsoleEndpointData } from './useConsoleEndpointData';

/**
 * This component manages the fetching of data for an endpoint. It does not render content.
 * Fetched data is stored in Recoil.
 *
 * @prop values          data from the event
 * @prop pollInterval    how often to re-fetch data
 */
const EndpointDataManager: DataManagerComponent = ({ values, pollInterval }) => {
  const detailsData = useConsoleEndpointData({ values, pollInterval });

  useDataManager(detailsData);

  return <></>;
};

export default EndpointDataManager;
